import { Icon } from '@mui/material';
import { NumberHashIcon } from '@synergy/theme-next';
import { fields } from '@synergy/utils';

import { EditOffer } from '../model/edit-offer';
import { OfferFooterConditionsItem } from './offers-footer-conditions-item';
import { PaymentTermAutocomplete } from '../../../../../common/components/payment-term-autocomplete/payment-term-autocomplete';

interface OfferFooterConditionsProps {
    bonusReadonly: boolean;
    readonly: boolean;
}

const fieldNames = fields<EditOffer>();

export const OfferFooterConditions = (props: OfferFooterConditionsProps) => {
    const { bonusReadonly, readonly } = props;

    return (
        <div>
            <OfferFooterConditionsItem
                icon={<Icon className="icon-payment" />}
                titleId="app.label.paymentTerm"
                fieldName={fieldNames.paymentTerm}
                readonly={readonly}
            >
                <PaymentTermAutocomplete name="paymentTerm" disabled={readonly} required={true} />
            </OfferFooterConditionsItem>
            <OfferFooterConditionsItem
                icon={<Icon className="icon-local_shipping" />}
                titleId="app.label.termsOfDelivery"
                fieldName="termsOfDeliveryContent"
                readonly={readonly}
            />
            <OfferFooterConditionsItem
                icon={<Icon className="icon-loyalty" />}
                titleId="app.label.supplierBonus"
                fieldName="supplierBonus"
                readonly={readonly || bonusReadonly}
            />
            <OfferFooterConditionsItem
                icon={<NumberHashIcon />}
                titleId="app.label.supplierOfferNumber"
                fieldName="supplierOfferNumber"
                readonly={readonly}
            />
        </div>
    );
};
